import type {BackgroundProps} from "@/styles/background.types";
import type {PaddingProps} from "@/styles/padding.types";
import type {MarginProps} from "@/styles/margin.types";
import type {TextProps} from "@/styles/text.types";
import type {FlexProps} from "@/styles/flex.types";
import type {WidthProps} from "@/styles/width.types";
import type {VisibilityProps} from "@/styles/visibility.types";

import {css} from "styled-components";
import {padding} from "@/styles/padding";
import {background} from "@/styles/background";
import {margin} from "@/styles/margin";
import {text} from "@/styles/text";
import {flex} from "@/styles/flex";
import {width} from "@/styles/width";
import {visibility} from "@/styles/visibility";
import {customScroolbar} from "@/styles/customScroolbar";
import Responsive from '@/styles/responsive'
import GlobalStyle from '@/styles/GlobalStyle';
import theme from "@/styles/theme";
import { CustomScroolbarProps } from "@/styles/customScroolbar.types";

export const Styles = css<StyleProps>`
  ${background}
  ${padding}
  ${margin}
  ${text}
  ${flex}
  ${width}
  ${visibility}
  ${customScroolbar}
`;

export interface StyleProps extends BackgroundProps, PaddingProps, MarginProps, TextProps, FlexProps, WidthProps, VisibilityProps, CustomScroolbarProps {
}

export {
  GlobalStyle,
  theme,
  Responsive
}
